import { Flex, Stack, Text, Box, Button } from "@mantine/core";
import { useEffect, useRef } from "react";
import lottie from "lottie-web";
import puzzleAnimation from "../../assets/puzzle_sambla.json";
import { FooterButtons } from "../footerButtons";
import { isMobileDevice } from "../../utils/useDeviceDetection";

interface BankIdPendingMessageProps {
  onCancel: () => void;
  processStatusInfo?: string | null;
}

export function BankIdPendingMessage({
  onCancel,
  processStatusInfo,
}: BankIdPendingMessageProps) {
  const animationContainer = useRef<HTMLDivElement>(null);

  const isMobile = isMobileDevice();

  useEffect(() => {
    const container = animationContainer.current;
    if (!container) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    const animation = lottie.loadAnimation({
      container,
      renderer: "svg",
      loop: !prefersReducedMotion,
      autoplay: !prefersReducedMotion,
      animationData: puzzleAnimation,
    });

    if (prefersReducedMotion) {
      animation.goToAndStop(Math.max(animation.totalFrames / 2), true);
    }

    return () => animation.destroy();
  }, []);

  const pendingText =
    processStatusInfo === "started"
      ? "BankID-appen har öppnats. Vänligen följ instruktionerna i appen."
      : "Skriv in din säkerhetskod i BankID-appen och välj Legitimera eller Skriv under.";

  return (
    <Flex justify={"center"} px={"lg"} pt={isMobile ? "2rem" : "7rem"}>
      <Stack align="center" gap="xl" maw="600px">
        <Text
          role="status"
          size="xl"
          fw={600}
          ta="center"
          style={{
            maxWidth: "500px",
            lineHeight: 1.5,
            color: "#2C3E50",
          }}
        >
          {pendingText}
        </Text>

        <Box
          ref={animationContainer}
          aria-hidden="true"
          style={{
            width: "200px",
            height: "200px",
            marginBottom: "2rem",
          }}
        />

        <FooterButtons>
          <Button variant="default" onClick={onCancel}>
            Avbryt
          </Button>
        </FooterButtons>
      </Stack>
    </Flex>
  );
}
